import { render, staticRenderFns } from "./DetailsLayout.vue?vue&type=template&id=1871b562&scoped=true&lang=html&"
import script from "./DetailsLayout.vue?vue&type=script&lang=js&"
export * from "./DetailsLayout.vue?vue&type=script&lang=js&"
import style0 from "./DetailsLayout.vue?vue&type=style&index=0&id=1871b562&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871b562",
  null
  
)

export default component.exports